<div class="addresses">
    <div class="addresses__add-new-address">
        <button mm-button
                size="large"
                fluid="true"
                routerLink="./create-address"
                [mmTestTarget]="'add-address-button'">
            <mm-icon name="add"></mm-icon>
            <span>
                {{ 'PAGES.ACCOUNT.ADDRESS_BOOK.ADD_NEW_ADDRESS' | translate }}
            </span>
        </button>
    </div>
    <div class="addresses__address-list" [mmTestId]="'ADDRESS_BOOK_PAGE.ADDRESS_LIST'">
        <div *ngFor="let addressData of templateOptions.addressData$ | async" class="addresses__address-list-item">
            <app-address [address]="addressData.address"
                         [actionList]="addressData.actionList"
                         (action)="onActionClick($event)">
                <div class="address-labels">
                    <div *ngIf="addressData?.address.defaultShipping"
                         class="address-labels__badge"
                         [mmTestTarget]="'default-shipping'">
                        {{ 'PAGES.ACCOUNT.ADDRESS_BOOK.DEFAULT_SHIPPING_LABEL' | translate }}
                    </div>
                    <div *ngIf="addressData?.address.defaultBilling"
                         class="address-labels__badge"
                         [mmTestTarget]="'default-billing'">
                        {{ 'PAGES.ACCOUNT.ADDRESS_BOOK.DEFAULT_BILLING_LABEL' | translate }}
                    </div>
                </div>
            </app-address>
        </div>
    </div>
</div>
